import {
  GrundpfandrechtMasterIdMeta,
  HistInfo,
  PfandrechtVersionDetailEntryMeta,
  RechteId,
  RechteIdMeta,
  RechtMasterId,
  RechtMasterIdMeta,
  RechtVersionListEntry
} from '../../../core/gb-api';
import { LinkComponent, NavTarget } from '../../components/link/link.component';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { DecimalPipe, NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { TranslatePipe } from '@ngx-translate/core';
import { FormatRechteIdPipe } from '../../pipes/format/format-rechte-id.pipe';
import { NamenInhaberPfandrechtartPipe } from '../../pipes/simple/namen-inhaber-pfandrechtart.pipe';
import { TranslateNamePipe } from '../../pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-kompakt-grundpfandrecht',
  templateUrl: './kompakt-grundpfandrecht.component.html',
  preserveWhitespaces: false,
  imports: [
    NgTemplateOutlet,
    LinkComponent,
    TranslatePipe,
    DecimalPipe,
    FormatRechteIdPipe,
    NamenInhaberPfandrechtartPipe,
    TranslateNamePipe
  ]
})
export class KompaktGrundpfandrechtComponent extends KompaktdarstellungTemplateComponent implements OnInit {
  @Input()
  masterId: RechtMasterId | RechtMasterIdMeta | GrundpfandrechtMasterIdMeta;
  @Input()
  rechteId: RechteId | RechteIdMeta;
  @Input()
  version: RechtVersionListEntry | PfandrechtVersionDetailEntryMeta;
  @Input()
  pfandstelle: number;

  // Histinfo kann mitgegeben werden wenn histInfo von der Verion übersteuert werden soll
  @Input()
  histInfo: HistInfo;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;
  @ViewChild('typ02', { static: true }) typ02Template: TemplateRef<any>;
  text: string = '';
  navTargets = NavTarget;

  constructor(formatService: FormatConfigService, location: PlatformLocation, locationStrategy: ComponentLocationStrategy) {
    super(formatService, 'GRUNDPFANDRECHT', location, locationStrategy);
    keysToTranslate<string>(['EINZELPFANDRECHT_KURZ', 'GESAMTPFANDRECHT_KURZ', 'TEILPFANDRECHT_KURZ', 'GESAMTTEILPFANDRECHT_KURZ']);
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.histInfo) {
      this.histInfo = this.version.histInfo;
    }
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'GRUNDPFANDRECHT_TYP00');
    this.bindTemplates(this.typ01Template, 'GRUNDPFANDRECHT_TYP01');
    this.bindTemplates(this.typ02Template, 'GRUNDPFANDRECHT_TYP02');
  }

  getQueryParams(version: RechtVersionListEntry | PfandrechtVersionDetailEntryMeta) {
    return { id: this.masterId.id, versionId: version.id.id };
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  protected readonly HistInfo = HistInfo;
}
